var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Flex } from "./grid";
import React from 'react';
import { styled, css } from "../utils";
var Wrapper = styled(Flex)(function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    a {\n      padding: 0 ", ";\n      &:first-of-type {\n        padding-left: 0;\n      }\n    }\n    a + a {\n      border-left: solid ", " 2px;\n    }\n  "], ["\n    a {\n      padding: 0 ", ";\n      &:first-of-type {\n        padding-left: 0;\n      }\n    }\n    a + a {\n      border-left: solid ", " 2px;\n    }\n  "])), space[1], colors.midnight);
});
var Link = styled.a(function (_a) {
    var _b = _a.theme, font = _b.font, colors = _b.colors, space = _b.space;
    return ({
        fontFamily: font.family.proximaNova,
        fontWeight: font.weight.bold,
        padding: "0 " + space[1] + "px",
        color: "" + colors.midnight,
    });
});
var FooterLinks = function (_a) {
    var links = _a.links;
    return (React.createElement(Wrapper, { "data-component": "FooterLinks", display: "flex", justifyContent: ['center', null, 'flex-start'] }, links.map(function (_a) {
        var text = _a.text, url = _a.url, target = _a.target;
        return (React.createElement(Link, { key: text, href: url, target: target }, text));
    })));
};
export default FooterLinks;
var templateObject_1;
//# sourceMappingURL=FooterLinks.js.map